<span *ngIf="dataReady">
  <span *ngIf="observation.id > 0">
    #<a [routerLink]="['/ors', activity, 'report', observation.id]">{{ observation.id }} {{ observation.title }}</a>
  </span>
  <span *ngIf="observation.id == 0">
    #? {{ observation.title }}
  </span>
</span>